import React, { useState, useRef } from 'react'
import emailjs from '@emailjs/browser';
import SimpleReactValidator from 'simple-react-validator';

const ContactForm = () => {
    const   formRef = useRef();

    const [forms, setForms] = useState({
        name: '',
        email: '',
        subject: '',
        phone: '',
        message: ''
    });

    const [validator] = useState(new SimpleReactValidator({ className: 'errorMessage' }));

    const changeHandler = e => {
        setForms({ ...forms, [e.target.name]: e.target.value });
        validator.showMessages();
    };

    const submitHandler = e => {
        e.preventDefault();

        if (validator.allValid()) {
            validator.hideMessages();
 
            // EmailJS integration
            emailjs.sendForm(
                'service_hf3fmkj',        // Replace with your EmailJS service ID
                'template_f7l8fav',       // Replace with your EmailJS template ID
                formRef.current,
                'UsIRF_fIEY6GHH4Ny'         // Replace with your EmailJS public key
            ).then(() => {
                alert('Message sent successfully!');
                setForms({
                    name: '',
                    email: '',
                    subject: '',
                    phone: '',
                    message: ''
                });
            }).catch((err) => {
                alert('Failed to send message, please try again.');
                console.error('EmailJS error:', err);
            });
        } else {
            validator.showMessages();
        }
    };

    return (
        <form ref={formRef} onSubmit={submitHandler}>
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                        <label className="input_title">Full Name</label>
                        <input
                            value={forms.name}
                            type="text"
                            name="name"
                            className="form-control"
                            onBlur={changeHandler}
                            onChange={changeHandler}
                            placeholder="Goladria Gomez" />
                        {validator.message('name', forms.name, 'required|alpha_space')}
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="form-group">
                        <label className="input_title">Your Email</label>
                        <input
                            value={forms.email}
                            type="email"
                            name="email"
                            className="form-control"
                            onBlur={changeHandler}
                            onChange={changeHandler}
                            placeholder="sales@laskontech.com" />
                        {validator.message('email', forms.email, 'required|email')}
                    </div>
                </div>

                <div className="col-12">
                    <div className="form-group">
                        <label className="input_title">Your Phone</label>
                        <input
                            value={forms.phone}
                            type="tel"
                            name="phone"
                            className="form-control"
                            onBlur={changeHandler}
                            onChange={changeHandler}
                            placeholder="+44 7466 436417" />
                        {validator.message('phone', forms.phone, 'required|phone')}
                    </div>
                </div>

                <div className="col-12">
                    <div className="form-group">
                        <label className="input_title">Message</label>
                        <textarea
                            onBlur={changeHandler}
                            onChange={changeHandler}
                            value={forms.message}
                            name="message"
                            className="form-control"
                            placeholder="How can we help you?">
                        </textarea>
                        {validator.message('message', forms.message, 'required')}
                    </div>

                    <button type="submit" className="btn btn-primary">
                        <span className="btn_label" data-text="Send Message">Send Message</span>
                        <span className="btn_icon">
                            <i className="fa-solid fa-arrow-up-right"></i>
                        </span>
                    </button>
                </div>
            </div>
        </form>
    )
}

export default ContactForm;
